// Ein Takt für alles, was „läuft" pulst (Tim 17.10.2026 zu den Punkten in
// der Statusleiste: „Das hier sollte im gleichen Takt blinken").
//
// Eine CSS-Animation beginnt, wenn ihr Element erscheint: zwei Punkte, die
// zu verschiedenen Zeiten kamen, blinken versetzt. Darum setzt jede
// Animation `laeuft-puls` (app.css) ihren Anfang auf den Nullpunkt der
// Seite (document.timeline) -- alle stehen in derselben Phase, auch was
// später dazukommt oder neu anläuft. Ohne Stores: das Recovery-Tool
// nimmt denselben Takt.

export const TAKT = "laeuft-puls";

export function starteTakt(doc: Document = document): void {
  doc.addEventListener(
    "animationstart",
    (e) => {
      if (e.animationName !== TAKT || !(e.target instanceof Element)) return;
      for (const a of e.target.getAnimations()) {
        if ((a as CSSAnimation).animationName === TAKT) a.startTime = 0;
      }
    },
    true,
  );
}
